<template>
    <div>
        <div ref="ref_qrcode" style="width: 100%; height: 200px; text-align: center; margin: 0">
            <!-- <p>点击"开始授权"按钮开始二维码扫描授权流程</p> -->
        </div>
        <Modal v-model="modalUnBindCheck" title="">
            <div style="text-align: center">
                <img style="border-radius: 100px" :src="headimgurl" />
                <div>{{ nickname }}</div>
            </div>
            <div style="text-align: center" v-if="isBindOpenId">当前账号已绑定微信，确定是否解绑</div>
            <div style="text-align: center" v-else>当前账号未绑定微信，确定是否绑定</div>
            <div slot="footer" style="text-align: right">
                <Button @click="modalUnBindCheck = false">下次再说</Button>
                <Button v-if="isBindOpenId" @click="unBinding" type="primary" style="margin-left: 10px">解绑</Button>
                <Button v-else @click="binding" type="primary" style="margin-left: 10px">绑定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
const ScanQRCodeAuth = window.ScanQRCodeAuth.default || window.ScanQRCodeAuth;
import { GetUserTempToken, BindOpenId, UnbindOpenId } from '@/request/api.js';
import ajax_config from '../../url.json';

//console.log(ScanQRCodeAuth);
// 创建新实例
const createQrCode = (container) => {
    const authInstance = new ScanQRCodeAuth({
        appId: '68bbec5eb3986a6c34abaef6', //授权发起APPID
        scene: 'log001', //发起授权场景编号
        container: container, //渲染二维码的编号
        sseUrl: 'https://dev.ruiziyou.com/oauth2/htapi', //授权请求地址(固定即可:后续不需要传递)
        state: new Date().getTime().toString(), //授权状态码:如果传递在消费code的时候需要传递
        //扫码授权成功回调
        onSuccess: async (data) => {
            debugger;
            console.log(`授权成功: ${JSON.stringify(data)}`);
            if (!data.isRedirect) {
                let res = await GetUserTempToken({
                    authCode: data.code,
                    statusCode: data.state,
                });
            }
        },
        //错误回调
        onError: (error) => {
            console.error(`错误: ${error.message}`);
        },
        //扫码状态编号回调
        onStatusChange: (data) => {
            console.log(`授权成功: ${JSON.stringify(data)}`);
        },
        //二维码生成参数
        qrCodeOptions: {
            width: 160,
        },
        showStatusBar: true, //是否显示默认状态框
    });
    return authInstance;
};

export default {
    name: 'qrScanCode',
    props: {
        scene: {
            type: String,
            default: 'login',
        },
        sceneType: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            scanQRCode: null,
            // sceneType: {
            //     login: 'log001',
            //     auth: 'bing001',
            // },
            modalUnBindCheck: false,
            token: '',
            statusCode: '',
            nickname: '',
            headimgurl: '',
            isBindOpenId: false,
        };
    },
    mounted() {
        // let isBindOpenId = localStorage.getItem('isBindOpenId');
        this.isBindOpenId = localStorage.getItem('isBindOpenId') == 'true' ? true : false;
        const container = this.$refs.ref_qrcode;
        if (this.scanQRCode) {
            //停止接收授权信息
            this.scanQRCode.stop();
            //销毁
            this.scanQRCode.destroy();
            this.scanQRCode = null;
        }
        //创建
        this.scanQRCode = this.createQrCode(container);
        this.scanQRCode.options.scene = this.sceneType[this.scene];
        // 开始授权流程
        this.scanQRCode.start();
    },
    methods: {
        async unBinding() {
            let res = await UnbindOpenId({
                token: this.token,
                statusCode: this.statusCode,
            });
            if (res.errcode != 0) return;
            localStorage.clear();
            window.location.replace('/');
        },
        /**
         * 最后一次确认绑定
         */
        async binding() {
            let res = await BindOpenId({
                token: this.token,
                statusCode: this.statusCode,
            });
            if (res.errcode != 0) return;
            localStorage.clear();
            window.location.replace('/');
        },
        createQrCode(container) {
            let appId = window.location.host.indexOf('localhost') != -1 ? ajax_config.devAppId : ajax_config.runAppId;
            let sseUrl = window.location.host.indexOf('localhost') != -1 ? ajax_config.devSseUrl : ajax_config.runSseUrl;

            let that = this;
            const authInstance = new ScanQRCodeAuth({
                appId: appId, //授权发起APPID
                scene: 'log001', //发起授权场景编号
                container: container, //渲染二维码的编号
                sseUrl: sseUrl, //授权请求地址(固定即可:后续不需要传递)
                state: new Date().getTime().toString(), //授权状态码:如果传递在消费code的时候需要传递
                //扫码授权成功回调
                onSuccess: async (data) => {
                    console.log(`授权成功: ${JSON.stringify(data)}${that}`);
                    if (!data.isRedirect) {
                        let res = await GetUserTempToken({
                            authCode: data.code,
                            statusCode: data.state,
                        });
                        if (res.errcode != 0) return;
                        this.token = res.data.token;
                        this.statusCode = res.data.statusCode;
                        this.nickname = res.data.nickname;
                        this.headimgurl = res.data.headimgurl;
                        that.modalUnBindCheck = true;
                        //创建
                        this.scanQRCode = this.createQrCode(container);
                        this.scanQRCode.options.scene = this.sceneType[this.scene];
                        // 开始授权流程
                        this.scanQRCode.start();
                    }
                },
                //错误回调
                onError: (error) => {
                    console.error(`错误: ${error.message}`);
                },
                //扫码状态编号回调
                onStatusChange: (data) => {
                    console.log(`授权成功: ${JSON.stringify(data)}`);
                },
                //二维码生成参数
                qrCodeOptions: {
                    width: 160,
                },
                showStatusBar: true, //是否显示默认状态框
            });
            return authInstance;
        },
    },
};
</script>
